import type { Logger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import ky from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";

interface RetrieveClaimPayload {
    partner: Partner;
    callSid: string;
    sessionId: string;
}

interface RetrieveClaimResult {
    deviceDescription: string;
    technologyType: string;
    zipCode: string;
    token: string;
}

export const retrieveClaim = async (
    ssoAccessToken: string,
    payload: RetrieveClaimPayload,
    verifyCustomerToken: string,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/retrieve-claim`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: { ...payload, token: verifyCustomerToken },
            timeout: defaultTimeoutInMS,
        });

        const result = await resp.json<RetrieveClaimResult>();
        return result;
    } catch (error) {
        logger.error({ error }, `Error: Could not retrieve claim for customer MDN.`);
        return { deviceDescription: undefined, technologyType: undefined, zipCode: undefined, token: undefined };
    }
};
